import Link from 'next/link'
import { useMemo, useState } from 'react'
import { ButtonWithIcon } from './input'

export function ConsentBanner() {
  const [shown, setShown] = useState(true)
  const showBanner = useMemo(() => {
    return typeof window == 'undefined'
      ? false
      : window?.localStorage?.getItem('cookie_consent') !== 'true' && shown
  }, [shown])

  const setConsent = () => {
    setShown(false)
    localStorage.setItem('cookie_consent', 'true')
  }

  return showBanner ? (
    <div
      className={`z-20 max-w-screen-lg mx-auto fixed bg-gray-800 text-gray-200
      dark:bg-white dark:text-gray-600 inset-x-5 p-5 bottom-5 rounded-lg drop-shadow-2xl
      flex gap-4 flex-wrap md:flex-nowrap text-center md:text-left items-center justify-center md:justify-between`}
    >
      <div className="w-full">
        We use cookies to make this site work, understand its usage, and
        remember your settings. If you continue to use this site we will assume
        that you are happy with it. You can read our{' '}
        <Link
          href="/privacy"
          className="dark:text-blue-600 text-blue-500 whitespace-nowrap hover:underline"
        >
          privacy policy
        </Link>{' '}
        here.
      </div>
      <div className="flex gap-4 items-center flex-shrink-0">
        <ButtonWithIcon onClick={setConsent} color="blue">
          I understand
        </ButtonWithIcon>
      </div>
    </div>
  ) : null
}
